export default function sv() {
  return {
    'main.title': 'Lantisen',
    'main.description': 'Lantisen är en beroendeframkallande patiens som går ut på att placera korten i ordning från 2 till kung i 4 rader.',

    'nav.newgame': 'Starta nytt spel',
    'nav.undomove': 'Ångra senaste drag',
    'nav.highscore': 'Visa topplista',
    'nav.statistics': 'Visa statistik',
    'nav.about': 'Om Lantisen',

    'game.highscore': 'Högst poäng i {month}: {name} ({score, number})',
    'game.round': 'Omgång: {round, number}/{rounds, number}',
    'game.score': 'Poäng: {score, number}',
    'game.moves': 'Drag: {moves, number}',
    'game.nextround': 'Nästa runda',
    'game.playagain': 'Spela igen',

    'about.title': 'Om Lantisen',
    'about.info': 'Lantisen går ut på att lägga samtliga kort i ordning från 2 till kung med en färg på varje rad. Vilken färg som läggs på respektive rad spelar ingen roll. Tvåor kan endast läggas i en lucka längst till vänster på spelplanen. Övriga kort kan endast läggas i en lucka till höger om det kort i samma färg som kommer före i ordningen. I en lucka efter kung kan inget kort läggas.',
    'about.help': 'Dra ett kort till rätt lucka eller dubbelklicka på kortet för att automatiskt hitta rätt plats. Klicka på en lucka så blinkar det kort som kan läggas i luckan.',
    'about.contact': 'Bli fan av Lantisen på Facebook! Där har du möjlighet att framföra synpunkter eller komma i kontakt med mig. Tack för att du spelar Lantisen!',

    'highscore.title': 'Topplista',
    'highscore.alltime': 'Bäst genom tiderna',
    'highscore.month': 'Bäst i {month}',

    'statistics.title': 'Statistik',
    'statistics.gamesPlayed': 'Spelade spel',
    'statistics.gamesLost': 'Förlorade spel',
    'statistics.gamesWonRound1': 'Vinst i omgång 1',
    'statistics.gamesWonRound2': 'Vinst i omgång 2',
    'statistics.gamesWonRound3': 'Vinst i omgång 3',
    'statistics.gamesWonRound4': 'Vinst i omgång 4',
    'statistics.gamesWonRound5': 'Vinst i omgång 5',

    'roundover.title': 'Slut på omgång {round}',
    'roundover.description': 'Inga fler drag kan göras, korten blandas om...',

    'gameover.title': 'Spelet är slut!',
    'gameover.description': 'Du misslyckades att slutföra Lantisen!',

    'gamewin.title': 'Grattis!',
    'gamewin.description': 'Du har lagt samtliga kort på rätt plats och slutfört Lantisen!',
    'gamewin.highscore': 'Du kom in på topplistan! Skriv in ditt namn för att spara din poäng.',
    'gamewin.nohighscore': 'Tyvärr kom du inte in på topplistan den här gången.',
    'gamewin.placeholder': 'Ange ditt namn',
    'gamewin.submit': 'Skicka'
  };
}
